import { render, staticRenderFns } from "./HelpBlockReadOnly.vue?vue&type=template&id=650358b0&"
import script from "./HelpBlockReadOnly.vue?vue&type=script&lang=js&"
export * from "./HelpBlockReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650358b0')) {
      api.createRecord('650358b0', component.options)
    } else {
      api.reload('650358b0', component.options)
    }
    module.hot.accept("./HelpBlockReadOnly.vue?vue&type=template&id=650358b0&", function () {
      api.rerender('650358b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/help-block/HelpBlockReadOnly.vue"
export default component.exports